"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import {globalStyles} from "../../styles/global";
// import {fontFamily} from "react-styleguidist/lib/client/styles/theme";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  dateBorder: function dateBorder(props) {
    return {
      fontFamily: "IranSansX!important",
      maxWidth: "668px",
      border: "1px solid ".concat(props.invalidFeedback ? _variables.colors.fire : _variables.colors.hare),
      backgroundColor: (props === null || props === void 0 ? void 0 : props.disabled) && (_variables.colors === null || _variables.colors === void 0 ? void 0 : _variables.colors.swan),
      borderRadius: "10px",
      display: "flex",
      justifyContent: "space-between",
      paddingRight: "20px",
      direction: "rtl",
      alignItems: "center",
      "& .MuiFormLabel-root": {
        fontFamily: "IranSansX !important"
      },
      "& label": {
        display: "none !important"
      },
      "& .MuiInput-underline": {
        margin: "0 !important",
        "&:before": {
          borderBottom: "none !important"
        },
        "&:after": {
          borderBottom: "none !important"
        },
        "&:hover": {
          "&:before": {
            borderBottom: "none !important"
          }
        }
      },
      "& input": {
        fontFamily: "IranSansX !important",
        color: props !== null && props !== void 0 && props.disabled ? _variables.colors === null || _variables.colors === void 0 ? void 0 : _variables.colors.whale : props.invalidFeedback ? _variables.colors.fire : _variables.colors.night,
        '&:before': {
          borderBottom: "none !important"
        },
        '&:after': {
          borderBottom: "none !important"
        }
      }
    };
  },
  label: function label(props) {
    return {
      fontFamily: "IranSansX",
      position: "absolute",
      top: "0",
      right: "10px",
      backgroundColor: _variables.colors.ghost,
      color: props.invalidFeedback ? _variables.colors.fire : _variables.colors.wolf,
      zIndex: "1",
      lineHeight: "1px",
      paddingLeft: "10px",
      paddingRight: "10px",
      textTransform: "capitalize"
    };
  },
  smLabel: {
    fontSize: "12px"
  },
  lgLabel: {
    fontSize: "14px"
  },
  sm: {
    fontSize: "10px",
    height: "48px"
  },
  lg: {
    fontSize: "14px",
    height: "60px"
  },
  invalidFeedback: {
    fontFamily: "IranSansX",
    width: "100%",
    marginTop: "6px",
    lineHeight: "13px",
    direction: "rtl",
    textAlign: "right",
    marginRight: "23px",
    color: _variables.colors.fire
  },
  line: {
    color: _variables.colors.wolf,
    marginLeft: "20px"
  },
  dateBox: {
    maxWidth: "668px",
    position: "relative"
  }
}), {
  name: 'pds-date-input'
});
exports.useStyles = useStyles;